/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Agent } from './Agent';
import {
    AgentFromJSON,
    AgentFromJSONTyped,
    AgentToJSON,
    AgentToJSONTyped,
} from './Agent';
import type { ListingStatusItem } from './ListingStatusItem';
import {
    ListingStatusItemFromJSON,
    ListingStatusItemFromJSONTyped,
    ListingStatusItemToJSON,
    ListingStatusItemToJSONTyped,
} from './ListingStatusItem';
import type { PropertyTypeItem } from './PropertyTypeItem';
import {
    PropertyTypeItemFromJSON,
    PropertyTypeItemFromJSONTyped,
    PropertyTypeItemToJSON,
    PropertyTypeItemToJSONTyped,
} from './PropertyTypeItem';
import type { HoaFeeDto } from './HoaFeeDto';
import {
    HoaFeeDtoFromJSON,
    HoaFeeDtoFromJSONTyped,
    HoaFeeDtoToJSON,
    HoaFeeDtoToJSONTyped,
} from './HoaFeeDto';

/**
 * 
 * @export
 * @interface SinglePropertyResponse
 */
export interface SinglePropertyResponse {
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    area: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    neighborhood: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    mlsId: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    mlsSource: string;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    yearBuilt: number;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    addressLine1: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    addressLine2: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    county: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    link: string;
    /**
     * 
     * @type {object}
     * @memberof SinglePropertyResponse
     */
    uPropertyId?: object;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    parkingGarageSpaces: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    parkingOtherSpaces: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    parkingCost: number;
    /**
     * 
     * @type {boolean}
     * @memberof SinglePropertyResponse
     */
    parkingTandem: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SinglePropertyResponse
     */
    parkingAttached: boolean;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    parkingType: string;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    unitCount: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    bedroomCount: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    bathroomCount: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    fullBathroomCount: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    halfBathroomCount: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    partialBathroomsCount: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    currentPrice: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    internalSize: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    costPerInternalSqFt: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    lotSize: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    costPerLotSqFt: number;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    description: string;
    /**
     * 
     * @type {Date}
     * @memberof SinglePropertyResponse
     */
    listDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SinglePropertyResponse
     */
    contingentDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SinglePropertyResponse
     */
    pendingDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SinglePropertyResponse
     */
    soldDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    hoaMonthlyFee: number;
    /**
     * 
     * @type {HoaFeeDto}
     * @memberof SinglePropertyResponse
     */
    hoaFee?: HoaFeeDto;
    /**
     * 
     * @type {PropertyTypeItem}
     * @memberof SinglePropertyResponse
     * @deprecated
     */
    propertyType: PropertyTypeItem;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    propertyTypeRaw: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    propertySubTypeRaw: string;
    /**
     * 
     * @type {ListingStatusItem}
     * @memberof SinglePropertyResponse
     */
    listingStatus: ListingStatusItem;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    hoaComments: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    hoaType: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    propertyDisclaimer: string;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    virtualTourUrl: string;
    /**
     * 
     * @type {Date}
     * @memberof SinglePropertyResponse
     */
    lastSourceUpdateDate: Date;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    soldPrice: number;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    listPrice: number;
    /**
     * 
     * @type {boolean}
     * @memberof SinglePropertyResponse
     */
    hasDoormanAttendance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SinglePropertyResponse
     */
    isLease: boolean;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    roomsTotal?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    taxAnnualAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    flipTaxType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SinglePropertyResponse
     */
    flipTax?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    flipTaxRemarks?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    patioAndPorchFeatures?: string | null;
    /**
     * 
     * @type {Agent}
     * @memberof SinglePropertyResponse
     */
    listingAgent: Agent;
    /**
     * 
     * @type {Array<Agent>}
     * @memberof SinglePropertyResponse
     */
    agents?: Array<Agent>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SinglePropertyResponse
     */
    photos?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SinglePropertyResponse
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof SinglePropertyResponse
     */
    waterfrontClassification?: SinglePropertyResponseWaterfrontClassificationEnum | null;
}


/**
 * @export
 */
export const SinglePropertyResponseWaterfrontClassificationEnum = {
    Waterfront: 'waterfront',
    NearWater: 'near_water'
} as const;
export type SinglePropertyResponseWaterfrontClassificationEnum = typeof SinglePropertyResponseWaterfrontClassificationEnum[keyof typeof SinglePropertyResponseWaterfrontClassificationEnum];


/**
 * Check if a given object implements the SinglePropertyResponse interface.
 */
export function instanceOfSinglePropertyResponse(value: object): value is SinglePropertyResponse {
    if (!('area' in value) || value['area'] === undefined) return false;
    if (!('neighborhood' in value) || value['neighborhood'] === undefined) return false;
    if (!('mlsId' in value) || value['mlsId'] === undefined) return false;
    if (!('mlsSource' in value) || value['mlsSource'] === undefined) return false;
    if (!('yearBuilt' in value) || value['yearBuilt'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('county' in value) || value['county'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('link' in value) || value['link'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('parkingGarageSpaces' in value) || value['parkingGarageSpaces'] === undefined) return false;
    if (!('parkingOtherSpaces' in value) || value['parkingOtherSpaces'] === undefined) return false;
    if (!('parkingCost' in value) || value['parkingCost'] === undefined) return false;
    if (!('parkingTandem' in value) || value['parkingTandem'] === undefined) return false;
    if (!('parkingAttached' in value) || value['parkingAttached'] === undefined) return false;
    if (!('parkingType' in value) || value['parkingType'] === undefined) return false;
    if (!('unitCount' in value) || value['unitCount'] === undefined) return false;
    if (!('bedroomCount' in value) || value['bedroomCount'] === undefined) return false;
    if (!('bathroomCount' in value) || value['bathroomCount'] === undefined) return false;
    if (!('fullBathroomCount' in value) || value['fullBathroomCount'] === undefined) return false;
    if (!('halfBathroomCount' in value) || value['halfBathroomCount'] === undefined) return false;
    if (!('partialBathroomsCount' in value) || value['partialBathroomsCount'] === undefined) return false;
    if (!('currentPrice' in value) || value['currentPrice'] === undefined) return false;
    if (!('internalSize' in value) || value['internalSize'] === undefined) return false;
    if (!('costPerInternalSqFt' in value) || value['costPerInternalSqFt'] === undefined) return false;
    if (!('lotSize' in value) || value['lotSize'] === undefined) return false;
    if (!('costPerLotSqFt' in value) || value['costPerLotSqFt'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('hoaMonthlyFee' in value) || value['hoaMonthlyFee'] === undefined) return false;
    if (!('propertyType' in value) || value['propertyType'] === undefined) return false;
    if (!('propertyTypeRaw' in value) || value['propertyTypeRaw'] === undefined) return false;
    if (!('propertySubTypeRaw' in value) || value['propertySubTypeRaw'] === undefined) return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined) return false;
    if (!('hoaComments' in value) || value['hoaComments'] === undefined) return false;
    if (!('hoaType' in value) || value['hoaType'] === undefined) return false;
    if (!('propertyDisclaimer' in value) || value['propertyDisclaimer'] === undefined) return false;
    if (!('virtualTourUrl' in value) || value['virtualTourUrl'] === undefined) return false;
    if (!('lastSourceUpdateDate' in value) || value['lastSourceUpdateDate'] === undefined) return false;
    if (!('soldPrice' in value) || value['soldPrice'] === undefined) return false;
    if (!('listPrice' in value) || value['listPrice'] === undefined) return false;
    if (!('hasDoormanAttendance' in value) || value['hasDoormanAttendance'] === undefined) return false;
    if (!('isLease' in value) || value['isLease'] === undefined) return false;
    if (!('listingAgent' in value) || value['listingAgent'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function SinglePropertyResponseFromJSON(json: any): SinglePropertyResponse {
    return SinglePropertyResponseFromJSONTyped(json, false);
}

export function SinglePropertyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SinglePropertyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'area': json['area'],
        'neighborhood': json['neighborhood'],
        'mlsId': json['mlsId'],
        'mlsSource': json['mlsSource'],
        'yearBuilt': json['yearBuilt'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'city': json['city'],
        'county': json['county'],
        'state': json['state'],
        'zipCode': json['zipCode'],
        'link': json['link'],
        'uPropertyId': json['uPropertyId'] == null ? undefined : json['uPropertyId'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'parkingGarageSpaces': json['parkingGarageSpaces'],
        'parkingOtherSpaces': json['parkingOtherSpaces'],
        'parkingCost': json['parkingCost'],
        'parkingTandem': json['parkingTandem'],
        'parkingAttached': json['parkingAttached'],
        'parkingType': json['parkingType'],
        'unitCount': json['unitCount'],
        'bedroomCount': json['bedroomCount'],
        'bathroomCount': json['bathroomCount'],
        'fullBathroomCount': json['fullBathroomCount'],
        'halfBathroomCount': json['halfBathroomCount'],
        'partialBathroomsCount': json['partialBathroomsCount'],
        'currentPrice': json['currentPrice'],
        'internalSize': json['internalSize'],
        'costPerInternalSqFt': json['costPerInternalSqFt'],
        'lotSize': json['lotSize'],
        'costPerLotSqFt': json['costPerLotSqFt'],
        'description': json['description'],
        'listDate': json['listDate'] == null ? undefined : (new Date(json['listDate'])),
        'contingentDate': json['contingentDate'] == null ? undefined : (new Date(json['contingentDate'])),
        'pendingDate': json['pendingDate'] == null ? undefined : (new Date(json['pendingDate'])),
        'soldDate': json['soldDate'] == null ? undefined : (new Date(json['soldDate'])),
        'hoaMonthlyFee': json['hoaMonthlyFee'],
        'hoaFee': json['hoaFee'] == null ? undefined : HoaFeeDtoFromJSON(json['hoaFee']),
        'propertyType': PropertyTypeItemFromJSON(json['propertyType']),
        'propertyTypeRaw': json['propertyTypeRaw'],
        'propertySubTypeRaw': json['propertySubTypeRaw'],
        'listingStatus': ListingStatusItemFromJSON(json['listingStatus']),
        'hoaComments': json['hoaComments'],
        'hoaType': json['hoaType'],
        'propertyDisclaimer': json['propertyDisclaimer'],
        'virtualTourUrl': json['virtualTourUrl'],
        'lastSourceUpdateDate': (new Date(json['lastSourceUpdateDate'])),
        'soldPrice': json['soldPrice'],
        'listPrice': json['listPrice'],
        'hasDoormanAttendance': json['hasDoormanAttendance'],
        'isLease': json['isLease'],
        'roomsTotal': json['roomsTotal'] == null ? undefined : json['roomsTotal'],
        'taxAnnualAmount': json['taxAnnualAmount'] == null ? undefined : json['taxAnnualAmount'],
        'flipTaxType': json['flipTaxType'] == null ? undefined : json['flipTaxType'],
        'flipTax': json['flipTax'] == null ? undefined : json['flipTax'],
        'flipTaxRemarks': json['flipTaxRemarks'] == null ? undefined : json['flipTaxRemarks'],
        'patioAndPorchFeatures': json['patioAndPorchFeatures'] == null ? undefined : json['patioAndPorchFeatures'],
        'listingAgent': AgentFromJSON(json['listingAgent']),
        'agents': json['agents'] == null ? undefined : ((json['agents'] as Array<any>).map(AgentFromJSON)),
        'photos': json['photos'] == null ? undefined : json['photos'],
        'active': json['active'],
        'waterfrontClassification': json['waterfrontClassification'] == null ? undefined : json['waterfrontClassification'],
    };
}

export function SinglePropertyResponseToJSON(json: any): SinglePropertyResponse {
    return SinglePropertyResponseToJSONTyped(json, false);
}

export function SinglePropertyResponseToJSONTyped(value?: SinglePropertyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'area': value['area'],
        'neighborhood': value['neighborhood'],
        'mlsId': value['mlsId'],
        'mlsSource': value['mlsSource'],
        'yearBuilt': value['yearBuilt'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'city': value['city'],
        'county': value['county'],
        'state': value['state'],
        'zipCode': value['zipCode'],
        'link': value['link'],
        'uPropertyId': value['uPropertyId'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'parkingGarageSpaces': value['parkingGarageSpaces'],
        'parkingOtherSpaces': value['parkingOtherSpaces'],
        'parkingCost': value['parkingCost'],
        'parkingTandem': value['parkingTandem'],
        'parkingAttached': value['parkingAttached'],
        'parkingType': value['parkingType'],
        'unitCount': value['unitCount'],
        'bedroomCount': value['bedroomCount'],
        'bathroomCount': value['bathroomCount'],
        'fullBathroomCount': value['fullBathroomCount'],
        'halfBathroomCount': value['halfBathroomCount'],
        'partialBathroomsCount': value['partialBathroomsCount'],
        'currentPrice': value['currentPrice'],
        'internalSize': value['internalSize'],
        'costPerInternalSqFt': value['costPerInternalSqFt'],
        'lotSize': value['lotSize'],
        'costPerLotSqFt': value['costPerLotSqFt'],
        'description': value['description'],
        'listDate': value['listDate'] === null ? null : ((value['listDate'] as any)?.toISOString()),
        'contingentDate': value['contingentDate'] === null ? null : ((value['contingentDate'] as any)?.toISOString()),
        'pendingDate': value['pendingDate'] === null ? null : ((value['pendingDate'] as any)?.toISOString()),
        'soldDate': value['soldDate'] === null ? null : ((value['soldDate'] as any)?.toISOString()),
        'hoaMonthlyFee': value['hoaMonthlyFee'],
        'hoaFee': HoaFeeDtoToJSON(value['hoaFee']),
        'propertyType': PropertyTypeItemToJSON(value['propertyType']),
        'propertyTypeRaw': value['propertyTypeRaw'],
        'propertySubTypeRaw': value['propertySubTypeRaw'],
        'listingStatus': ListingStatusItemToJSON(value['listingStatus']),
        'hoaComments': value['hoaComments'],
        'hoaType': value['hoaType'],
        'propertyDisclaimer': value['propertyDisclaimer'],
        'virtualTourUrl': value['virtualTourUrl'],
        'lastSourceUpdateDate': ((value['lastSourceUpdateDate']).toISOString()),
        'soldPrice': value['soldPrice'],
        'listPrice': value['listPrice'],
        'hasDoormanAttendance': value['hasDoormanAttendance'],
        'isLease': value['isLease'],
        'roomsTotal': value['roomsTotal'],
        'taxAnnualAmount': value['taxAnnualAmount'],
        'flipTaxType': value['flipTaxType'],
        'flipTax': value['flipTax'],
        'flipTaxRemarks': value['flipTaxRemarks'],
        'patioAndPorchFeatures': value['patioAndPorchFeatures'],
        'listingAgent': AgentToJSON(value['listingAgent']),
        'agents': value['agents'] == null ? undefined : ((value['agents'] as Array<any>).map(AgentToJSON)),
        'photos': value['photos'],
        'active': value['active'],
        'waterfrontClassification': value['waterfrontClassification'],
    };
}

